import React from 'react';
import { CheckIcon } from 'lucide-react';
import { OFFER_ANCHOR, PRODUCT_IMG } from './constants';
const features = ['Visual diagnostic workflows', 'Fault-finding sequences', 'Testing guides', 'Diagnostic decision trees', 'Scan-data references', 'Professional workshop tools'];
const areas = ['Workflow', 'Fuel', 'Turbo', 'Electronics', 'Emissions', 'Faults'];
export function SystemSection() {
  return <section className="bg-brand-carbon px-4 py-5 text-white" data-id="element-161" data-mp="31kz24o6b9xn9">
      <div className="mx-auto max-w-4xl" data-id="element-162" data-mp="31mjz0kg3lsoa">
        <h2 className="mb-1 text-center font-display text-[20px] leading-tight text-white sm:text-3xl" data-id="element-163" data-mp="2wsxtrdc9kr2i">
          The Complete <span className="text-brand-yellow" data-id="element-164" data-mp="2st6sugt0wuk9">6-in-1</span> Diagnostic System
        </h2>
        <p className="mb-3 text-center font-cond text-sm font-bold uppercase tracking-wide text-brand-yellow sm:text-lg" data-id="element-165" data-mp="2nudk11oolrqf">
          🔧 DIESEL DIAGNOSTIC PRO™
        </p>

        <div className="grid items-center gap-4 sm:grid-cols-2" data-id="element-166" data-mp="2duml8nt38qkj">
          <a href={OFFER_ANCHOR} className="block cursor-pointer" aria-label="Go to the offer" data-id="element-167" data-mp="2dx7n3ctdz6ia">
            
          </a>

          <div data-id="element-168" data-mp="18pocwz3usiex">
            <ul className="mb-3 flex flex-wrap gap-1.5" data-id="element-169" data-mp="18q6hcj0o62xx">
              {areas.map(area => <li key={area} className="rounded border border-brand-yellow/60 px-2 py-0.5 font-cond text-[11px] font-semibold uppercase tracking-wide text-brand-yellow" data-id="element-170" data-mp="u11v8qqr7ekj">
                  {area}
                </li>)}
            </ul>
            <ul className="space-y-1.5" data-id="element-171" data-mp="1mqr23kq5a8u2">
              {features.map(feature => <li key={feature} className="flex items-start gap-2 text-[13px] font-semibold sm:text-base" data-id="element-172" data-mp="1rois2978bkvm">
                  <CheckIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-brand-yellow" strokeWidth={3} data-id="element-173" data-mp="1cs1gbgv4o48j" />
                  {feature}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}